export const appearanceFeatureFlags = {
  globalSearch: 'global-search',
  toolbarNotifications: 'appearance.toolbarNotifications',
  toolbarHelp: 'appearance.toolbarHelp',
  lightModeDefault: 'appearance.lightModeDefault',
  themeModeToggle: 'appearance.themeModeToggle',
  metricTrendCards: 'appearance.metricTrendCards',
  statusTrendPreviewCharts: 'appearance.statusTrendPreviewCharts',
} as const;

export const appAppearanceFeatureFlagKeys = [
  appearanceFeatureFlags.globalSearch,
  appearanceFeatureFlags.toolbarNotifications,
  appearanceFeatureFlags.toolbarHelp,
  appearanceFeatureFlags.themeModeToggle,
  appearanceFeatureFlags.metricTrendCards,
  appearanceFeatureFlags.statusTrendPreviewCharts,
] as const;

export const superuserAppearanceFeatureFlagKeys = [
  appearanceFeatureFlags.globalSearch,
  appearanceFeatureFlags.toolbarNotifications,
  appearanceFeatureFlags.toolbarHelp,
  appearanceFeatureFlags.lightModeDefault,
  appearanceFeatureFlags.themeModeToggle,
  appearanceFeatureFlags.metricTrendCards,
  appearanceFeatureFlags.statusTrendPreviewCharts,
] as const;

export const isFeatureFlagEnabled = (
  flags: Record<string, boolean> | null | undefined,
  key: string,
): boolean => flags?.[key] === true;
